(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('collection-liste', {
            parent: 'entity',
            url: '/collection-liste?page&sort&search&etat&collecteur&startDate&endDate',
            data: {
                authenticate: true,
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.collectionListe.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/collection-liste/collection-listes.html',
                    controller: 'CollectionListeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'referenceCollectionList,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('collectionListe');
                    $translatePartialLoader.addPart('etatCollectionList');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('collection-liste-detail', {
            parent: 'entity',
            url: '/collection-liste/{id}',
            data: {
                authenticate: true,
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.collectionListe.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/collection-liste/collection-liste-detail.html',
                    controller: 'CollectionListeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('collectionListe');
                    $translatePartialLoader.addPart('etatCollectionList');
                    $translatePartialLoader.addPart('contrat');
                    return $translate.refresh();
                }]
            /*,
                entity: ['$stateParams', 'CollectionListe', function($stateParams, CollectionListe) {
                    return CollectionListe.get({id : $stateParams.id});
                }]*/
            }
        })
        .state('collection-liste-map', {
            parent: 'entity',
            url: '/collection-liste/{id}/map',
            data: {
                authenticate: true,
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.collectionListe.map.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/collection-liste/collection-liste-map.html',
                    controller: 'CollectionListeMapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('collectionListe');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('collection-liste.new', {
            parent: 'collection-liste',
            url: '/new',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/collection-liste/collection-liste-dialog.html',
                    controller: 'CollectionListeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            	collecteur: null,
                                dateFinPeriode: null,
                                listPortefeuilleContratDTO: null
                              //  etat: null,
                               // id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('collection-liste', null, { reload: true });
                }, function() {
                    $state.go('collection-liste');
                });
            }]
        })
        .state('collection-liste.delete', {
            parent: 'collection-liste',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/collection-liste/collection-liste-delete-dialog.html',
                    controller: 'CollectionListeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CollectionListe', function(CollectionListe) {
                            return {id : $stateParams.id};
                        }]
                    }
                }).result.then(function() {
                    $state.go('collection-liste', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
